import { RequestServices } from '../../../../@types/requests';
import Loading from '../../../../Components/Loading';
import dateFormat from '../../../../utils/dateFormat';
import NotFound from '../NotFound';
import { CustomTable } from './style';

interface TableServicesProps {
  results: RequestServices[];
  loading: boolean;
}

const TableServices = ({ results, loading }: TableServicesProps) => {
  return (
    <CustomTable responsive="md">
      <thead className="table-header">
        <tr>
          <th>Status</th>
          <th>Protocolo</th>
          <th>Atendente</th>
          <th>Data de Atendimento</th>
        </tr>
      </thead>
      <tbody className="table-body">
        {loading ? (
          <tr>
            <td colSpan={7}>
              <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '850px' }}>
                <Loading />
              </div>
            </td>
          </tr>
        ) : results && results.length > 0 ? (
          results.map((request) => (
            <tr key={request.id}>
              <td>{request.status}</td>
              <td>{request.protocolo}</td>
              <td>{request.user?.first_name || 'Nenhum atendente registrado.'}</td>
              <td>{dateFormat(request.created_at, true)}</td>
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={7}>
              <NotFound />
            </td>
          </tr>
        )}
      </tbody>
    </CustomTable>
  );
};

export default TableServices;